/* global $:false */

import 'modernizr.js'

export default class CommonLotShowGallerySwipeHint {
  static init () {
    Array.from($('.js-common-lot-show-carousel')).map((el) =>
      new CommonLotShowGallerySwipeHint(el))
  }

  constructor (el) {
    this.el = $(el)
    if (this.hasScrolledBefore()) { return }
    this.findElements()
    this.observeCarouselScroll()
    this.swipeHint.addClass('c-common-lot-show-carousel__swipe-hint--show-on-small')
  }

  findElements () {
    this.swipeHint = this.el.find('.js-common-lot-show-carousel__swipe-hint')
  }

  observeCarouselScroll () {
    this.el.on('scroll', () => this.scrolled())
  }

  scrolled () {
    // Thottling to avoid CPU usage
    if (this._scrolled) { return }
    this._scrolled = true
    this.swipeHint.hide()
    this.remember()
  }

  remember () {
    if (!window.Modernizr.localstorage) { return }
    window.localStorage.setItem(this.cacheKey(), 'true')
  }

  hasScrolledBefore () {
    if (!window.Modernizr.localstorage) { return }
    return window.localStorage.getItem(this.cacheKey())
  }

  cacheKey () {
    return 'lot-show-gallery-swiped'
  }
}
